import { render } from "./rbac.authorization.k8s.io.role.vue?vue&type=template&id=7bc67be8"
import script from "./rbac.authorization.k8s.io.role.vue?vue&type=script&lang=js"
export * from "./rbac.authorization.k8s.io.role.vue?vue&type=script&lang=js"

import exportComponent from "../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__